module.exports = __webpack_public_path__ + "static/media/splash.0602a72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/splash.jpg
// module id = 238
// module chunks = 1